exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#image {\n  border: none;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  max-height: 80%;\n  max-width: 80%;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n#image.hide {\n  opacity: 0; }\n\n#wrapper {\n  height: 100%;\n  position: absolute;\n  transition: background-color 0.15s 0.15s ease, opacity 0.25s ease;\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/splash/splash.component.scss
// module id = 416
// module chunks = 1